export function init_header() {

    let scrollPos = 0;
    const body = document.querySelector('body');

    function debounce(func, wait = 10, immediate = true) {
            let timeout;

            return function() {
                let context = this, args = arguments;

                let later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };

                let callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }

        function checkPosition() {
            let windowY = window.scrollY;
            if (windowY < scrollPos) {
            body.classList.remove('is-smaller');
            } else {
            body.classList.add('is-smaller');
            }
            scrollPos = windowY;
        }

    window.addEventListener('scroll', debounce(checkPosition));
}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/header.js